import { motion } from "framer-motion";
import { Award, Compass, Shield } from "lucide-react";

const values = [
  {
    icon: Award,
    title: "Excelencia",
    description: "Cada proyecto es tratado con la precisión que tu trayectoria merece."
  },
  {
    icon: Compass,
    title: "Estrategia",
    description: "Decisiones fundamentadas en metodología probada globalmente."
  },
  {
    icon: Shield,
    title: "Confidencialidad",
    description: "Tu legado empresarial protegido bajo los más altos estándares."
  }
];

const AboutUs = () => {
  return (
    <section className="relative overflow-hidden" id="quienes-somos">
      {/* First part with light background */}
      <div className="py-24 md:py-32 bg-background">
        <div className="container px-4">
          {/* Section header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-left mb-16"
          >
            <span className="text-primary text-sm font-semibold tracking-widest uppercase mb-4 block">
              10 · Quiénes Somos
            </span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              We are <span className="text-gradient-gold">CORESSEN®</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl">
              Una consultora global especializada en <span className="text-foreground font-medium">Arquitectura de Reputación©</span>. 
              Transformamos empresas consolidadas con trayectoria en <span className="text-foreground font-medium">instituciones de referencia y autoridad</span> en sus mercados.
            </p>
          </motion.div>

          {/* About text + Values */}
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
            {/* Left column - About text */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="space-y-6 text-muted-foreground"
            >
              <p>
                Durante más de <span className="text-foreground font-semibold">13 años</span>, hemos acompañado a líderes empresariales de{" "}
                <span className="text-foreground font-semibold">Latinoamérica, Europa y Estados Unidos</span> en la construcción de marcas que trascienden. 
                Nuestra razón de ser es transformar la trayectoria de organizaciones consolidadas en sistemas de prestigio que operen con autonomía y visión global.
              </p>
              <p>
                Creamos <span className="text-foreground font-semibold">ecosistemas estratégicos</span> diseñados específicamente para maximizar el valor percibido de tu organización.
              </p>
              <p>
                Este enfoque de autor se sostiene en una{" "}
                <span className="text-foreground font-semibold">metodología propia y en criterio estratégico</span>, 
                además de ser el motor de nuestra propia consultora. No implementamos teorías; aplicamos una{" "}
                <span className="text-foreground font-semibold">metodología de resultados reales y tangibles</span>.
              </p>
              <p className="text-sm">
                Coressen Global se fundó en junio de 2024 como consultora estratégica de marca. La trayectoria previa de sus socios es individual y se declara como tal.
              </p>

              <p>
                Proyectamos marcas que hablan el lenguaje del éxito en cualquier mercado. Diseñamos la identidad y la estrategia necesarias para que tu empresa sea la{" "}
                <span className="text-foreground font-semibold">opción preferida de los clientes más exigentes</span>.
              </p>
            </motion.div>

            {/* Right column - Values */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="space-y-4"
            >
              {values.map((value, index) => (
                <motion.div
                  key={value.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                  className="p-6 rounded-xl border border-border bg-card hover:border-primary/30 transition-colors"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                      <value.icon className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-semibold mb-1">{value.title}</h3>
                      <p className="text-muted-foreground text-sm">{value.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
